import { useRouter, useShowArticles } from '@application/utils';
import { useEffect } from 'react';

export const useRedirectArticles = () => {
  const { navigateToRoute } = useRouter();
  const { shouldShowArticles } = useShowArticles();

  useEffect(() => {
    if (!shouldShowArticles) {
      navigateToRoute('homeLanding');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowArticles]);
};
